import { useMutation } from '@tanstack/react-query';
import { LOGIN_BASE_REQUEST } from '@sib/auth';
import { msalInstance } from '@sib/auth';
import { useAuthStore } from '@sib/auth';
import { tracking } from '@sib/tracking';

export const useLogin = () => {
  const { setAccount } = useAuthStore();

  return useMutation({
    mutationFn: async () => {
      msalInstance.clearCache();
      const data = await msalInstance.loginPopup({
        ...LOGIN_BASE_REQUEST,
        prompt: 'select_account',
      });

      msalInstance.setActiveAccount(data.account);

      tracking.setUser({
        email: data.account.username || '',
        name: data.account.name || '',
      });
      setAccount(data.account);

      return data;
    },
  });
};
